import 'css-chunksrc/client/scenes/calendar/weeklyView/styles.scss';export default {
  "weeklyView": "_weeklyView_1aija_1",
  "labels": "_labels_1aija_5",
  "dayName": "_dayName_1aija_11"
};